export default {
  toucanTitle: 'Mutualisez en toute autonomie',
  colinorTitle: 'Bienvenue sur Colinor',
  colinorSubtitle: 'Connectez-vous pour transporter en mode partage',
  toucanSubtitle: 'La plateforme collaborative de votre entreprise',
  login: 'Se connecter',
  poweredBy: 'Propulsé par',
  toucan: 'Toucan Solutions',
};
